import { getImgBaseUrl } from './getImgBaseUrl';

export const getFontUrl = (fontFamilyId: string, fontId: string) =>
  `${getImgBaseUrl()}/fontFamilies/${fontFamilyId}/fonts/${fontId}.woff`;
